function resolveImageSources(context, product) {
    product.styles.forEach(style => {
        style.items.forEach(item => {
            if (item.image) {
                item.image = resolveImageSource(context, item.image);
            }
            item.images = item.images.map(image => {
                return {
                    ...image,
                    preview: resolveImageSource(context, image.preview),
                    detail: resolveImageSource(context, image.detail)
                };
            });
        });
    });
    return product;
}

function resolveImageSourcesForBundleReviewModel(context, bundleReviewModel) {
    bundleReviewModel.products.forEach(product => {
        const image = product.image;
        product.image = {
            ...image,
            preview: resolveImageSource(context, image.preview),
            detail: resolveImageSource(context, image.detail)
        };
    });
    return bundleReviewModel;
}

function resolveImageSource(context, imageDefinition) {
    const dimensionProfile = context.dimensionProfiles[imageDefinition.profileName];
    const sources = Object.entries(dimensionProfile.dimensions)
        .map(([breakpoint, dimensions]) => createImageSource(context, imageDefinition, breakpoint, dimensions));
    return {
        alt: imageDefinition.alt,
        title: imageDefinition.title,
        lazy: imageDefinition.lazy,
        fallbackSource: createImageSource(context, imageDefinition, 'ALL', dimensionProfile.fallbackDimensions),
        sources
    };
}

function createImageSource(context, imageDefinition, breakpoint, dimensions) {
    const baseUrl = context.imageBaseUrl;
    const mediaQueries = context.mediaQueries;
    const srcPathDefinition = context.pathDefinitions["x1"];
    const src2xPathDefinition = context.pathDefinitions["x2"];

    const dimensionsPath = `${dimensions.width}x${dimensions.height}`;
    const imagePath = imageDefinition.pathDefinition.path;

    return {
        mediaQuery: mediaQueries[breakpoint],
        srcSet: {
            src: constructPath(baseUrl, srcPathDefinition, {dim: dimensionsPath, path: imagePath}),
            src2x: constructPath(baseUrl, src2xPathDefinition, {dim: dimensionsPath, path: imagePath}),
        }
    };
}

function constructPath(baseUrl, pathDefinition, placeholderValues) {
    if(pathDefinition.full) {
        return pathDefinition.path;
    }
    const placeholders = pathDefinition.placeholders || [];
    const initialPath = baseUrl ? baseUrl + pathDefinition.path : pathDefinition.path;
    return placeholders.reduce((path, placeholder) => {
        return path.replace(`{${placeholder}}`, placeholderValues[placeholder]);
    }, initialPath);
}

export default {
    resolveImageSources,
    resolveImageSourcesForBundleReviewModel
}